/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
Vue.component(
    "favorability-component",
    require("./components/FavorabilityComponent.vue").default
);
Vue.component(
    "fa-pie-chart",
    require("./components/FaPieChartComponent.vue").default
);
Vue.component(
    "process-assets-component",
    require("./components/ProcessAssetsComponent.vue").default
);
Vue.component(
    "campaign-status-component",
    require("./components/CampaignStatusComponent.vue").default
);
Vue.component(
    "campaign-queue-component",
    require("./components/CampaignQueueComponent.vue").default
);
Vue.component(
    "process-all-component",
    require("./components/ProcessAllCampaignsComponent.vue").default
);
Vue.component("v-select", vSelect);
Vue.component(
    "model-select",
    require("./components/ModelSelectComponent.vue").default
);
/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// Only mount Vue if the page needs it (no data-no-vue attribute on body)
if (!document.body.hasAttribute('data-no-vue')) {
    const app = new Vue({
        el: "#app"
    });
}
